import Toastr from "../../../components/Toastr"
const parent = 'SETTING_'

const DEFAULT_STATE = {
  api_keys: [],
  api_key: {},
  meta: { pagination: {} },
  saving: false,
  editing: false
}

let changes = null;
export default function apiKeysReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let apiKeys = [];
  let apiKeyData = [];
  let updatedRecord = {};

  switch (action.type) {
    case `${parent}API_KEYS_CREATE_PENDING`:
    case `${parent}API_KEYS_UPDATE_PENDING`:
    case `${parent}API_KEYS_DELETE_PENDING`:
      return { ...state, saving: true };

    case `${parent}API_KEYS_LOAD_REJECTED`:
    case `${parent}API_KEY_LOAD_REJECTED`:
    case `${parent}API_KEYS_CREATE_REJECTED`:
    case `${parent}API_KEYS_UPDATE_REJECTED`:
    case `${parent}API_KEYS_DELETE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false
      }
      return { ...state, ...changes };

    case `${parent}API_KEYS_LOAD_FULFILLED`:
      changes = {
        meta: response.meta,
        api_keys: response['settings/api_keys'],
        saving: false
      };
      return { ...state, ...changes };

    case `${parent}API_KEY_LOAD_FULFILLED`:
      changes = {
        contact: response,
        saving: false
      }
      return { ...state, ...changes };

    case `${parent}API_KEY_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      apiKeys = [...state.api_keys]
      let newRecord = response['settings/api_key']
      changes = {
        api_keys: [newRecord, ...apiKeys],
        editing: false,
        saving: false
      }
      return { ...state, ...changes };

    case `${parent}API_KEY_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      apiKeys = [...state.api_keys];
      updatedRecord = response['settings/api_key'];
      for (const [index, key] of apiKeys.entries()) {
        if (key.id === updatedRecord.id) {
          apiKeyData = [
            ...apiKeys.slice(0, index),
            updatedRecord,
            ...apiKeys.slice(index + 1)
          ];
        }
      }
      changes = {
        api_keys: apiKeyData,
        saving: false
      };
      return { ...state, ...changes };

    case `${parent}API_KEY_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      apiKeys = [...state.api_keys];
      for (const [index, key] of apiKeys.entries()) {
        if (key.id === response['settings/api_key'].id) {
          apiKeys.splice(index, 1);
        }
      }
      return {
        ...state,
        api_keys: apiKeys,
      };

    case `${parent}API_KEY_EDIT`:
      changes = {
        editing: action.data,
      };
      return { ...state, ...changes };

    case `${parent}API_KEY_EDIT_CANCEL`:
      changes = {
        editing: false,
        api_key: {}
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}